import React, { Fragment, useState } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';

import { openSignUpModal } from '../../../store/modals/actions';
import { CLUSTER_HEADER_CATEGORY } from '../../../utils/constant';
import CareerClusterHeaderTitle from '../careerClusterHeader/CareerClusterHeaderTitle';
import SearchBar from '../common/SearchBar';
import SubHeader from '../common/SubHeader';

const SalaryMatchesHeader = ({
  subPageName,
  clusterCategory,
  subPageTextSmall,
  ...data
}) => {
  const { title, jobTitleArticle } = data.criteria;
  const { locationDisplay, dynamicPageName } = data;

  const [pageTitle, setPageTitle] = useState('');

  return (
    <Fragment>
      <div className="job-title-search container d-flex flex-column-reverse flex-lg-row align-items-start">
        <CareerClusterHeaderTitle
          subPageName={subPageName}
          title={title}
          subPageTextSmall={subPageTextSmall}
          clusterCategory={clusterCategory}
          getPageTitle={(_pageTitle) => setPageTitle(_pageTitle)}
        />
        <SearchBar
          subPageName={subPageName}
          dynamicPageName={dynamicPageName}
          clusterCategory={CLUSTER_HEADER_CATEGORY.CAREER}
          jobLocation={locationDisplay}
          jobTitleArticle={jobTitleArticle}
          className={classNames('z-mt-12 z-mb-20 z-mb-lg-0 z-ml-lg-20', {
            'z-mt-lg-44': pageTitle.length > 40,
            'z-mt-lg-40': pageTitle.length <= 40,
          })}
        />
      </div>
      <div className="sub-header-container">
        <SubHeader {...data} />
      </div>
    </Fragment>
  );
};

const mapDispatchToProps = {
  openSignUpModal,
};

export default connect(
  ({ user }) => ({
    user,
  }),
  mapDispatchToProps
)(SalaryMatchesHeader);
